/* Sportconic winkelwagenpagina (main-cart-sportconic).
   - Aantal/verwijderen op de pagina zelf: cart-API-call, daarna deze sectie
     verversen via de Section Rendering API.
   - De drawer-flows uit sportconic-cart.js (garantie-radio's, "+ Toevoegen",
     wees-opruimer) roepen op deze pagina window.spCartPageApply aan: drawer
     stil bijwerken (zonder hem te openen, wat Dawn's renderContents wel doet)
     en daarna de pagina verversen. */
(function () {
  if (window.__spCartPageInit) return;
  window.__spCartPageInit = true;
  if (!document.querySelector('[data-spcp]')) return;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getInner(html, sel) {
    var dom = new DOMParser().parseFromString(html, 'text/html');
    var el = sel ? dom.querySelector(sel) : dom.body;
    return el ? el.innerHTML : html;
  }

  /* Drawer-DOM en header-teller bijwerken zonder de drawer te openen. */
  function applyDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !data) return;
    if (typeof data.item_count === 'number') {
      drawer.classList.toggle('is-empty', data.item_count === 0);
    }
    var s = data.sections || {};
    if (s['cart-drawer']) {
      var target = drawer.querySelector('#CartDrawer');
      if (target) {
        target.innerHTML = getInner(s['cart-drawer'], '#CartDrawer');
        /* Dawn bindt de overlay-klik opnieuw na elke render; wij dus ook. */
        var ov = drawer.querySelector('#CartDrawer-Overlay');
        if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    if (s['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = getInner(s['cart-icon-bubble'], '.shopify-section');
    }
  }

  /* Sectie opnieuw renderen (debounced — meerdere snelle mutaties = één fetch). */
  var refreshTimer = null;
  function refreshSection() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var root = document.querySelector('[data-spcp]');
      var wrap = root && root.closest('.shopify-section');
      if (!wrap || !wrap.id) return;
      var id = wrap.id.replace('shopify-section-', '');
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || !data[id]) return;
          var wrapNow = document.querySelector('#' + wrap.id);
          if (wrapNow) wrapNow.outerHTML = data[id];
        })
        .catch(function () {
          var r = document.querySelector('[data-spcp]');
          if (r) r.classList.remove('is-busy');
        });
    }, 120);
  }

  window.spCartPageApply = function (data) {
    applyDrawer(data);
    refreshSection();
  };

  function post(url, body) {
    var root = document.querySelector('[data-spcp]');
    if (root) root.classList.add('is-busy');
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    fetch(routeRoot + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { window.spCartPageApply(data); })
      .catch(function () { if (root) root.classList.remove('is-busy'); });
  }

  /* Aantal wijzigen gaat via cart/change.js op de line-key: dat raakt precies één
     regel. cart/update.js werkt op variant-id en is onbetrouwbaar zodra dezelfde
     variant op twee regels staat — wat gebeurt wanneer Shopify's BXGY-korting
     "FREE GIFT" een loopbandregel splitst in een gekorte en niet-gekorte eenheid.
     Voor verwijderen is variant-id juist prima: daar wíl je alle regels van die
     variant (en de bijbehorende cadeau-/garantieregels) in één keer op 0 zetten. */
  function change(key, quantity) { post('cart/change.js', { id: key, quantity: quantity }); }
  function mutate(updates) { post('cart/update.js', { updates: updates }); }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-spcp-minus]');
    var plus = e.target.closest('[data-spcp-plus]');
    var remove = e.target.closest('[data-spcp-remove]');
    if (!minus && !plus && !remove) return;
    var item = e.target.closest('[data-spcp-item]');
    if (!item) return;
    e.preventDefault();
    var vid = item.getAttribute('data-vid');
    var key = item.getAttribute('data-key');
    var qty = parseInt(item.getAttribute('data-qty'), 10) || 0;
    var updates = {};
    if ((plus || (minus && qty > 1)) && key) {
      change(key, plus ? qty + 1 : qty - 1);
      return;
    }
    if (plus) {
      updates[vid] = qty + 1;
    } else if (minus && qty > 1) {
      updates[vid] = qty - 1;
    } else if (item.hasAttribute('data-sp-tread')) {
      /* Loopband verwijderen → cadeaus + garantie mee (anders blijven die als wees achter). */
      (item.getAttribute('data-sp-bundle') || '').split(',').filter(Boolean).forEach(function (v) { updates[v] = 0; });
      var self = item.getAttribute('data-sp-self');
      if (self) updates[self] = 0;
    } else {
      updates[vid] = 0;
    }
    mutate(updates);
  });

  /* Wijzigingen die búiten deze pagina-code om de drawer verversen (bv. Dawn's
     eigen drawer-interacties als iemand de drawer tóch opent op deze pagina):
     drawer-DOM in de gaten houden en de pagina meeverversen. */
  var cd = document.querySelector('cart-drawer');
  if (cd && window.MutationObserver) {
    new MutationObserver(function () { refreshSection(); }).observe(cd, { childList: true, subtree: true });
  }
})();
